export default "__VITE_ASSET__BY3f9LOA__"